import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

//Components
import BTicketAccessInfoLoungesFasttrack from './b-ticket-access-info-lounges-fasttrack/b-ticket-access-info-lounges-fasttrack.vue';
import BTicketAccessInfoParking from './b-ticket-access-info-parking/b-ticket-access-info-parking.vue';

// Constants
import { BARRIER_ACCESS_TYPES } from '@white-label-configuration/constants';

// Helpers
import { getAppVariable } from '@white-label-helper/get-app-variable';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-access-info',
  props: {
  //prop to choose which child to render
  type: {
    type: String,
    required: true,
    validator: (value: string) => ['loungesFasttrack', 'parking'].includes(value),
  },

  //shared prop
  accessInfo: {
    type: [Object, String],
    required: true,
  },

  //props used only by the lounges-fasttrack child
  accessInfoFromEntranceInfo: {
    type: Boolean,
    default: false,
  },
  subItems: {
    type: Array,
    default: () => [],
  },
  hideViewTicketsButton: {
    type: Boolean,
    default: false,
  },
  showProviderLogo: {
    type: Boolean,
    default: false,
  },
  product: {
    type: Object,
    default: () => ({}),
  },

  //props used only by the parking child
  // eslint-disable-next-line vue/require-default-prop
  accessInfoNumber: {
    type: Number,
    required: false,
  },
  licensePlate: {
    type: String,
    default: '',
  },
  extendedFlow: {
    type: Boolean,
    default: false,
  },
  walletPasses: {
    type: Object as () => { apple?: { url: string }; google?: { url: string } },
    default: () => ({}),
  },
},
  setup(__props, { expose }) {

const props = __props;




//select  child component - based on type prop
const childComponent = computed(() => {
 return props.type === 'loungesFasttrack'
    ? BTicketAccessInfoLoungesFasttrack
    : BTicketAccessInfoParking;
});

// TEMPORARY: Hide the parking QR code access section for the Christchurch partner.
// The Christchurch partner's `partner_name` is guaranteed to contain this token.
// Remove this computed (and its template usage) once a partner-config flag is available.
const hideQrCodeForChristchurch = computed(() => {
  if (props.type !== 'parking') return false;
  if (
    typeof props.accessInfo !== 'object'
    || props.accessInfo === null
    || props.accessInfo.type !== BARRIER_ACCESS_TYPES.QRCODE
  ) {
    return false;
  }
  const partnerName = getAppVariable<string>('partner_name', '');
  return partnerName.toLowerCase().includes('christchurch');
});

const { type, ...restProps } = props;
let childProps = restProps;
if (props.type !== 'parking') {
  const { accessInfoNumber, licensePlate, ...filteredProps } = childProps;
  childProps = filteredProps;
};

expose({
  childComponent,
  childProps,
  hideQrCodeForChristchurch,
});

return { __sfc: true,props, childComponent, hideQrCodeForChristchurch, type, restProps, childProps }
}

})